/** A person's name and face, in the few words and letters the room draws them with. */

/** "Priya", for the short words on the plate and in the host's card. */
export function firstWord(name: string): string {
  return name.trim().split(/\s+/)[0] || name;
}

/**
 * "PR" for Priya Kumar, for a face with the camera off. A number in the name is kept whole, since it is what tells
 * one guest from the next: "Guest 14" is G14, not G1.
 */
export function initialsOf(name: string): string {
  const words = name.split(/\s+/).map((w) => w.replace(/[^\p{L}\p{N}]/gu, "")).filter(Boolean);
  const number = words.find((w) => /^\p{N}+$/u.test(w));
  const letters = words.filter((w) => w !== number).map((w) => Array.from(w)[0] ?? "").join("");
  if (number) return (number.length > 2 ? number : `${letters.slice(0, 1)}${number}`).toUpperCase();
  return letters.slice(0, 2).toUpperCase() || "?";
}

/**
 * The workspace's host photo, for a host of that name only. A teammate who hosts gets their initials:
 * the profile host's face never stands in for someone else.
 */
export function photoOfHost(name: string, profileName: string, profilePhoto: string | null): string | null {
  return profilePhoto && name.trim().toLowerCase() === profileName.trim().toLowerCase() ? profilePhoto : null;
}
